import React from 'react'
import LOGO from '../../IMG/logo192.jpg'
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import {
    XMarkIcon,
    Bars3Icon,
    UserCircleIcon,
    ArrowRightOnRectangleIcon,
    ClipboardDocumentListIcon,
    ShieldCheckIcon,
    ShoppingBagIcon,
    GiftIcon,
    AcademicCapIcon
} from '@heroicons/react/24/outline'

const Menu = ({ iden = [] }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

    // เพิ่มไอคอนให้กับรายการเพื่อความสวยงาม (เลือกใช้ตามความเหมาะสม)
    const products = [
        { name: 'รายชื่อสมัครงาน', href: '/home/report/registration', icon: ClipboardDocumentListIcon },
        { name: 'รายชื่อประกันสุขภาพ', href: '/home/Health-insurance', icon: ShieldCheckIcon },
        { name: 'สั่งซื้อเสื้อพนักงาน', href: '/home/report/Order-a-Shirt', icon: ShoppingBagIcon },
        { name: 'สวัสดิการเสื้อพนักงาน', href: '/home/report/Welfare-Shirt', icon: GiftIcon },
        { name: 'จัดการอบรม', href: '/home/training-management', icon: AcademicCapIcon },
    ]

    const profile = [
        { name: 'ออกจากระบบ', href: '/login', icon: ArrowRightOnRectangleIcon },
    ]

    return (
        <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 shadow-sm">
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-4 lg:px-8">
                
                {/* Logo Section */}
                <div className="flex lg:flex-1">
                    <Link to="/home" className="-m-1.5 p-1.5 flex items-center gap-3 group transition-all">
                        <div className="relative">
                            <img alt="Logo" src={LOGO} className="h-10 w-auto rounded-xl shadow-sm group-hover:shadow-indigo-200 group-hover:scale-105 transition-all duration-300" />
                            <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-black/5" />
                        </div>
                        <span className="font-extrabold text-xl tracking-tight bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                            ราชพฤกษ์ไตเทียม
                        </span>
                    </Link>
                </div>

                {/* Mobile Menu Button */}
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-xl p-2.5 text-gray-700 hover:bg-gray-100/80 transition-all active:scale-95"
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon aria-hidden="true" className="h-7 w-7" />
                    </button>
                </div>

                {/* Desktop Main Menu */}
                <PopoverGroup className="hidden lg:flex lg:gap-x-2">
                    <Popover className="relative">
                        <PopoverButton className="flex items-center gap-x-1.5 px-4 py-2 text-sm font-semibold leading-6 text-gray-700 hover:text-indigo-600 hover:bg-indigo-50/50 rounded-full transition-all duration-200 outline-none">
                            เมนูบริการ
                            <ChevronDownIcon aria-hidden="true" className="h-4 w-4 flex-none text-gray-400 group-hover:text-indigo-500" />
                        </PopoverButton>

                        <PopoverPanel
                            transition
                            className="absolute -left-8 top-full z-10 mt-3 w-80 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-900/5 transition data-[closed]:translate-y-2 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150"
                        >
                            <div className="p-2">
                                {products.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className="group relative flex items-center gap-x-4 rounded-xl p-3 text-sm leading-6 hover:bg-indigo-50 transition-all duration-200"
                                    >
                                        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white group-hover:shadow-sm transition-all">
                                            {item.icon && <item.icon className="h-5 w-5 text-gray-600 group-hover:text-indigo-600" />}
                                        </div>
                                        <div className="flex-auto text-gray-700 group-hover:text-indigo-700 font-medium transition-colors">
                                            {item.name}
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </PopoverPanel>
                    </Popover>
                    
                    {/* เมนูที่ 2 (ถ้ามี) สามารถใส่เพิ่มตรงนี้ได้ตาม Logic เดิมของคุณ */}
                </PopoverGroup>

                {/* Desktop Profile Section */}
                <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                    <Popover className="relative">
                        <PopoverButton className="flex items-center gap-x-3 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-100/50 p-1.5 pr-4 rounded-full transition-all duration-200 outline-none group">
                            <div className="h-9 w-9 rounded-full bg-gradient-to-tr from-indigo-600 to-violet-500 flex items-center justify-center text-white shadow-md group-hover:shadow-indigo-200 transition-all overflow-hidden">
                                {iden?.firstName ? (
                                    <span className="text-sm font-bold uppercase">{iden.firstName.charAt(0)}</span>
                                ) : (
                                    <UserCircleIcon className="h-6 w-6" />
                                )}
                            </div>
                            <div className="text-left flex flex-col justify-center">
                                <span className="text-gray-900 leading-none mb-0.5">คุณ{iden?.firstName}</span>
                                <span className="text-[10px] text-gray-400 font-normal leading-none">{iden?.email || 'No email'}</span>
                            </div>
                        </PopoverButton>

                        <PopoverPanel
                            transition
                            className="absolute right-0 top-full z-10 mt-3 w-56 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-900/5 transition data-[closed]:translate-y-2 data-[closed]:opacity-0"
                        >
                            <div className="p-2">
                                {profile.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="flex items-center gap-x-3 rounded-xl p-3 text-sm font-semibold text-gray-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
                                    >
                                        <item.icon className="h-5 w-5 opacity-80" />
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                        </PopoverPanel>
                    </Popover>
                </div>
            </nav>

            {/* Mobile Menu Dialog */}
            <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                <div className="fixed inset-0 z-50 bg-gray-900/30 backdrop-blur-sm transition-opacity" />
                <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm transition-all duration-300 ease-in-out">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img alt="Logo" src={LOGO} className="h-9 w-auto rounded-lg" />
                            <span className="font-bold text-gray-900">เมนูหลัก</span>
                        </div>
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-xl p-2.5 text-gray-500 hover:bg-gray-100"
                        >
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                    </div>
                    
                    <div className="mt-8 flow-root">
                        <div className="-my-6 divide-y divide-gray-100">
                            <div className="space-y-1 py-6">
                                <p className="px-3 text-[11px] font-bold text-gray-400 uppercase tracking-[0.1em] mb-2">เมนูบริการ</p>
                                {products.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="flex items-center gap-3 rounded-xl py-3 px-3 text-base font-semibold leading-7 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-all"
                                    >
                                        {item.icon && <item.icon className="h-5 w-5 text-gray-400" />}
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                            
                            <div className="py-6">
                                <div className="px-3 py-4 mb-2 bg-gray-50 rounded-2xl flex items-center gap-3">
                                    <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold">
                                        {iden?.firstName?.charAt(0) || '?'}
                                    </div>
                                    <div>
                                        <p className="text-sm font-bold text-gray-900">คุณ{iden?.firstName} {iden?.lastName}</p>
                                        <p className="text-xs text-gray-500 truncate w-40">{iden?.email}</p>
                                    </div>
                                </div>
                                {profile.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="flex items-center gap-3 rounded-xl py-3 px-3 text-base font-semibold leading-7 text-red-600 hover:bg-red-50 transition-all"
                                    >
                                        <item.icon className="h-5 w-5" />
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </DialogPanel>
            </Dialog>
        </header>
    )
}

export default Menu